module.exports = __webpack_public_path__ + "media/images/folder_1-db8fa853.png";